"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCustomAttributes = exports.init = void 0;
var newrelic = null;
var init = function (instance) {
    if (!instance) {
        throw 'NewRelic instance is required!';
    }
    newrelic = instance;
};
exports.init = init;
var addCustomAttributes = function (obj) {
    if (newrelic.addCustomAttributes) {
        newrelic.addCustomAttributes(obj);
    }
};
exports.addCustomAttributes = addCustomAttributes;
